<template>
  <div class="ui grid">
    <div class="three wide column"> 
      <div class="ui secondary vertical pointing menu" style="width: 100%">
        <a class="item" :class="{ active: currentTab === tabs.first }"
              @click="currentTab = tabs.first">
          Reservations
        </a>
        <a class="item" :class="{ active: currentTab === tabs.second }"
              @click="currentTab = tabs.second">
          Packages
        </a>
        <a class="item" :class="{ active: currentTab === tabs.third }"
              @click="currentTab = tabs.third">
          Visits
        </a>
        <a class="item" :class="{ active: currentTab === tabs.fourth }"
              @click="currentTab = tabs.fourth">
          Transactions status
        </a>
      </div>
    </div>
    <div class="thirteen wide column">
      <h3 class="ui dividing header" style="margin-bottom: 20px">
        {{ currentTab }}
      </h3> 
      <reservations 
        :reservations="reservations"
        :visits="visits"
        v-if="currentTab === tabs.first" 
      />

      <resvaitonPackages 
        :reservations="reservations"
        :visits="visits" 
        :transactions="transactions"
        v-if="currentTab === tabs.second" 
      />

      <visits 
        :reservations="reservations"
        :visits="visits" 
        v-if="currentTab === tabs.third" 
      />

      <transactionStatus
        :lastReservationsTransactions="lastReservationsTransactions"
        v-if="currentTab === tabs.fourth" 
      />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    reservations: require('./applications_components/Reservations').default,
    visits: require('./applications_components/Visits').default,
    resvaitonPackages: require('./applications_components/Packages').default,
    transactionStatus: require('./applications_components/TransactionStatus').default
  },
  props: {
    visits: { type: Array, required: true },
    transactions: { type: Array, default: () => [] },
    reservations: { type: Array, required: true },
    lastReservationsTransactions: { type: Array, required: true }
  },
  data() {
    const tabs = {
      first: 'Patient reservation',
      second: 'Patient packages',
      third: 'Patient visits',
      fourth: 'Transaction status'
    }
    return {
      tabs: tabs,
      currentTab: tabs.second
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/Applications.vue